import { Component } from '@angular/core';
import { StandardClientsViewWrapperComponent } from '@app/pages/quote/standard-quote/read-only/clients-view/clients-view-wrapper.component';

@Component({
  selector: 'app-customer-view-desktop',
  templateUrl: './clients-view-desktop.component.html',
  styleUrls: ['./clients-view-desktop.component.scss'],
})
export class StandardClientsViewDesktopComponent extends StandardClientsViewWrapperComponent {
}
